<template>
  <div class="footer d-flex justify-center flex-col align-center">
    <div class="block-width">
      <img
        src="@/assets/images/footer-image.webp"
        class="w-100"
        style="height: auto; aspect-ratio: auto 1100 / 218;"
        width="1100"
        height="218"
        alt="footer image"
      />
      <div class="d-flex justify-between flex-wrap" style="padding: 20px 0;">
        <div class="footer-content">
          <p class="mb-075 text-body">{{ $t('address') }}</p>
          <p class="mb-075 text-body">+7 7172 97 26 26</p>
          <p class="mb-075 text-body">company@quant-tech.kz</p>
          <TheButtonPrimary :content="$t('contact_us')" @click="goTo('contact-us')"/>
        </div>
        <div class="mr-2 footer-content">
          <p class="text-body mb-1">{{ $t('solutions') }}</p>
          <p class="text-body c-metal-400 mb-1">{{ $t('solutions_1') }}</p>
          <p class="text-body c-metal-400 mb-1">{{ $t('solutions_2') }}</p>
          <p class="text-body c-metal-400 mb-1">{{ $t('solutions_3') }}</p>
          <p class="text-body c-metal-400 mb-1">{{ $t('solutions_4') }}</p>
          <p class="text-body c-metal-400 mb-1">{{ $t('solutions_5') }}</p>
          <div class="d-flex text-body c-metal-400">
            {{ $t('see_all') }}
            <img src="@/assets/images/icons/arrow-gray.svg" class="ml-05" alt="icon"/>
          </div>
        </div>
        <div class="mr-2 footer-content">
          <p class="text-body mb-1">{{ $t('integrations') }}</p>
          <p class="text-body c-metal-400 mb-1">{{ $t('integrations_1') }}</p>
          <p class="text-body c-metal-400 mb-1">{{ $t('integrations_2') }}</p>
          <p class="text-body c-metal-400 mb-1">{{ $t('integrations_3') }}</p>
          <p class="text-body c-metal-400 mb-1">1C</p>
          <p class="text-body c-metal-400 mb-1">Enbek</p>
          <div class="d-flex text-body c-metal-400">
            {{ $t('see_all') }}
            <img src="@/assets/images/icons/arrow-gray.svg" class="ml-05" alt="icon"/>
          </div>
        </div>
        <div class="mr-3 footer-content">
          <p class="text-body mb-1">{{ $t('resources') }}</p>
          <p class="text-body c-metal-400 mb-1">{{ $t('resources_1') }}</p>
          <p class="text-body c-metal-400 mb-1">{{ $t('resources_2') }}</p>
          <p class="text-body c-metal-400 mb-1">{{ $t('resources_3') }}</p>
          <p class="text-body c-metal-400 mb-1">{{ $t('resources_4') }}</p>
          <p class="text-body c-metal-400 mb-1">{{ $t('resources_5') }}</p>
        </div>
      </div>
    </div>
    <div class="footer-bottom">
      <div class="block-width pt-1 pb-1 d-flex justify-between align-center flex-wrap">
        <div class="d-flex footer__left mr-1">
          <p @click="goTo('confidentiality')" class="text-sm mr-05 cursor-pointer">{{ $t('policy') }}</p>
          <p class="text-sm cursor-pointer" @click="goTo('term-of-use')">{{ $t('rules') }}</p>
        </div>
        <p class="text-sm footer__middle mr-1">© 2024 ТОО “QUANT TECH”. {{ $t('rights_reserved') }}</p>
        <img src="@/assets/images/logos/workspace-white.svg" class="footer__right" alt="Workspace logo"/>
      </div>
    </div>
  </div>
</template>
<script setup>
import TheButtonPrimary from "@/components/TheButton/TheButtonPrimary.vue";
import {useRouter} from "vue-router";

const router = useRouter()
const goTo = (name) => {
  router.push({name: name, params: {message: 'message_text_1'}})
}
</script>